export default __webpack_public_path__ + "static/media/bg-performance-0.b4c0acda.png";